import React from 'react';
import { useState,useEffect } from 'react';
import { Route, useNavigate, Link, redirect } from "react-router-dom";
import { withRouter } from "react-router-dom";
import axios from 'axios';
import Produit from './produit';
import { useHistory } from 'react-router-dom';
import {browserHistory} from "react-router";
import Sidebar from './component/Sidebar';
import AdminUserBadge from './component/AdminUserBadge';

//var avigation = require('react-router-dom').Navigation;

//var navigate = require('react-router-dom').useNavigate();
function Ajoutproduit(){
    // navigate = Navigate();
     //navigate("/produit");
     const [selectedFile,setselectedFile] = useState([]);
     const [responseArray,setresponseArray] = useState([]);
     const [nomproduit,setnomproduit] = useState("");
     const [categorie,setcategorie] = useState("");
     const [description,setdescription] = useState("");
     const [souscategorie,setsouscategorie] = useState("");
     const [souscategorie2,setsouscategorie2] = useState("");
     const [souscategorie3,setsouscategorie3] = useState("");
     const [prix,setprix] = useState("");
     const [stock,setstock] = useState("");
     const [nomfournisseur,setnomfournisseur] = useState("");
     const [listecategorie,setlistecategorie] = useState([]);
     const [listesouscategorie,setlistesouscategorie] = useState([]);
     const [listesouscategorie2,setlistesouscategorie2] = useState([]);
     const [loader,setloader] = useState(false);

  const navigate = useNavigate();


  var urllistecategorie = "https://jojomarket.org/adminfood/categorie.php?alllistecategorie";

  const loadListe = async(url)=>{
    const response = await axios.get(url);

    console.log(response.data);
    setlistecategorie(response.data);
  
  }
  function handleInputChange(event){

    setselectedFile(event.target.files);
    setresponseArray([]);
    // this.setState({
    //   selectedFile: event.tarsget.files,
    //   responseArray:[],
      

    // });
  
  };
  useEffect(()=>{
    
    loadListe(urllistecategorie);
  }, []);

  const filtrersouscategorie = async(idcategorieparent1)=>{
    var lessouscategorie = listecategorie.filter(function (e){
      return e.idcategorieparent == idcategorieparent1;
    })
    setlistesouscategorie(lessouscategorie);
console.log('sous categorie---'+lessouscategorie);
   }

  const filtrersouscategorie2 = (idcategorieparent1)=>{
    let lessouscategorie2 = listecategorie.filter(function (e){
      return e.idcategorieparent == idcategorieparent1;
    })
    setlistesouscategorie2(lessouscategorie2);
   }
  
  function onSubmit() {
  
    if (!selectedFile) {
      alert("Please select a file!");
      return false;
    }
    const data = new FormData();

    for (let i = 0; i < selectedFile.length; i++) {
      data.append("file[]", selectedFile[i]);
    }
   
    data.append("nomproduit", nomproduit);
    data.append("categorie", souscategorie2);
    data.append("categoriesimilaire", souscategorie3);
    data.append("prix", prix);
    data.append("stock", stock);
    data.append("nomfournisseur", nomfournisseur);
    data.append("description", description);
    //data.append("prix", this.state.prix);
    let url = "https://jojomarket.org/adminfood/uploadfichier.php";
   
    axios
      .post(url, data, {
        // receive two parameter endpoint url ,form data
      })
      .then((res) => {
        // then print response status
        //this.setState({ responseArray: res.data });
       // setresponseArray(res.data);
       // resetFile();
        navigate('/produit');
     //alert('super');
       // this.push = () => {
        //this.props.router.push('/produit');
       //   };

       //this.state.redirect && <Navigate to='/produit' replace={true}/>
    //this.state.history.push("/produit");
    
       //this.window.location('/produit');
      },error=>{
        alert(error);
      });
     
  }

  function resetFile(){
    // Reset file input control
    document.getElementsByName("file")[0].value = "";
    setselectedFile([]);
    setresponseArray([]);
    setnomproduit("");
    setcategorie("");
    setdescription("");
    setsouscategorie("");
    setsouscategorie2("");
    setsouscategorie3("");
    setprix("");
    setstock("");
    setnomfournisseur("");
  }

  return (
    <div>
     <div><Sidebar/></div>
  <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg " style={{marginLeft: "260px"}}>
    {/* Navbar */}
  
  {/* Navbar */}
  <nav className="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl" id="navbarBlur" navbar-scroll="true">
      <div className="container-fluid py-1 px-3">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
            <li className="breadcrumb-item text-sm"><a className="opacity-5 text-dark" href="javascript:;">Accueil</a></li>
            <li className="breadcrumb-item text-sm text-dark active" aria-current="page">Ajout Produit</li>
          </ol>
          <h6 className="font-weight-bolder mb-0">Ajout Produit</h6>
        </nav>
        <div className="collapse justify-content-end navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
          <ul className="navbar-nav justify-content-end align-items-center">
            <li className="nav-item d-flex align-items-center">
              <Link to="/ajoutproduit" className="btn btn-outline-primary btn-sm mb-0 me-3"> + Ajouter</Link>
            </li>
            <AdminUserBadge className="me-3" />
            <li className="nav-item d-flex align-items-center">
              <Link to="/login" className="nav-link text-body font-weight-bold px-0">
                <i className="fa fa-user me-sm-1" />
                <span className="d-sm-inline d-none">Deconnexion</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    {/* End Navbar */}
    <div className="container-fluid py-4">
      <div className="row">
        <div className="col-12">
          <div className="card mb-4">
            <div className="card-header pb-0">
              <h6>Ajouter un article</h6>
         
            </div>




            <div class="col-xl-4 col-lg-5 col-md-7 mx-auto">

            
              
            <div class="card z-index-0">
              





{loader?<img src="loader.gif" height="100" width="100"/>:<div class="card-body">
                <form role="form text-left">
                  <div class="mb-3">
                    <input type="text" class="form-control"  placeholder="Nom"
         name='nomproduit' onChange={(e) => setnomproduit(e.target.value)}
         value={nomproduit} aria-label="Name" aria-describedby="email-addon"/>
                  </div>
                  <div class="mb-3">
                    <input type="text" class="form-control"  placeholder="Prix"
         name='prix' onChange={(e) => setprix(e.target.value)}
         value={prix} aria-label="Email" aria-describedby="email-addon"/>
                  </div>
                  <div class="mb-3">


                  <div class="form-group">
    <label for="exampleFormControlSelect1">Categorie</label>
    <select class="form-control" onChange={(e) => {setcategorie(e.target.value); filtrersouscategorie(e.target.value);}}
         value={categorie} id="exampleFormControlSelect1">
      <option value="">Selectionner</option>
      {listecategorie && listecategorie.map((item,index)=>(
        item.idcategorieparent==0?
      <option value={item.idcategorie}>{item.nomcategorie}</option>:<></>
))}
     
    </select>
  </div>
                  <div class="form-group">
    <label for="exampleFormControlSelect1">Menu Categorie</label>
    <select class="form-control" onChange={(e) => {setsouscategorie(e.target.value); filtrersouscategorie2(e.target.value);}}
         value={souscategorie} id="exampleFormControlSelect1">
      <option value="">Selectionner</option>
      {listesouscategorie && listesouscategorie.map((item,index)=>(
      <option value={item.idcategorie}>{item.nomcategorie}</option> 
))}
     
    </select>
  </div>
                  <div class="form-group">
    <label for="exampleFormControlSelect1">Menu sous Categorie</label>
    <select class="form-control" onChange={(e) =>  setsouscategorie2(e.target.value)}
         value={souscategorie2} id="exampleFormControlSelect1">
      <option value="">Selectionner</option>
      {listesouscategorie2 && listesouscategorie2.map((item,index)=>(
      <option value={item.idcategorie}>{item.nomcategorie}</option> 
))}
     
    </select>
  </div>
                  <div class="form-group">
    <label for="exampleFormControlSelect1">Similaire Categorie fiche produit</label>
    <select class="form-control" onChange={(e) =>  setsouscategorie3(e.target.value)}
         value={souscategorie3} id="exampleFormControlSelect1">
      <option value="">Selectionner</option>
      {listecategorie && listecategorie.map((item,index)=>(
        item.idcategorieparent==souscategorie2?
      <option value={item.idcategorie}>{item.nomcategorie}</option> 
      :     <></>
))}
     
    </select>
  </div>



                  </div>
                  <div class="mb-3">
                    <input type="text" class="form-control" placeholder='Nom du founisseur'   name='nomfournisseur' onChange={(e) => setnomfournisseur(e.target.value)}
         value={nomfournisseur}  aria-label="Email" aria-describedby="email-addon"/>
                  </div>
                  <div class="mb-3">
                    <textarea type="text" class="form-control" placeholder='Description'   name='description' onChange={(e) => setdescription(e.target.value)}
         value={description}  aria-label="" aria-describedby="email-addon">
          </textarea>
                  </div>
                  <div class="mb-3">
                    <input type="text" class="form-control"  placeholder="Stock"
         name='stock' onChange={(e) => setstock(e.target.value)}
         value={stock} aria-label="Email" aria-describedby="email-addon"/>
                  </div>
                  <div class="mb-3">
                    <input  type="file"
      multiple
        name="file"
onChange={handleInputChange} class="form-control"  aria-label="Password" aria-describedby="password-addon"/>
                  </div>
                 
                  <div class="text-center">
                    <button type="button" onClick={() => {setloader(true); onSubmit(); }} class="btn bg-gradient-dark w-100 my-4 mb-2">Enregister</button>
                  </div>
                    </form>
              </div>




      }



            </div>
          </div>














          </div>
        </div>
      </div>
    </div>

    <footer className="footer pt-3  ">
        <div className="container-fluid">
          <div className="row align-items-center justify-content-lg-between">
            <div className="col-lg-6 mb-lg-0 mb-4">
              <div className="copyright text-center text-sm text-muted text-lg-start">
                © H2A.
              </div>
            </div>
        
          </div>
        </div>
      </footer>
    </main>
    </div>
   
  )
}



export default Ajoutproduit